import { render, staticRenderFns } from "./detailTransfer.vue?vue&type=template&id=1c9dbcf3&scoped=true"
import script from "./detailTransfer.js?vue&type=script&lang=js&external"
export * from "./detailTransfer.js?vue&type=script&lang=js&external"
import style0 from "./detailTransfer.vue?vue&type=style&index=0&id=1c9dbcf3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9dbcf3",
  null
  
)

export default component.exports